import { cn } from '../lib/cn';

/**
 * Maclaren mark: a lowercase "m" of two arches with a dot, like a
 * cursor at the end of a message. Monochrome: it takes the text colour. Same geometry as public/icon.svg.
 *
 * `motion`: `draw` traces the arches and pops the dot (intro),
 * `breathe` slowly pulses the dot, `think` pulses it fast while the
 * model works. CSS animations live in base.css (.mc-mark-*), and stop
 * under reduced motion.
 */
export function LogoMark({
  className,
  motion,
}: {
  className?: string;
  motion?: 'draw' | 'breathe' | 'think';
}) {
  return (
    <svg
      viewBox="38 64 166 134"
      aria-hidden="true"
      className={cn('overflow-visible', motion && `mc-mark mc-mark-${motion}`, className)}
    >
      <path
        className="mc-mark-arches"
        pathLength={1}
        d="M56 176V114a32 32 0 0 1 64 0v62m0-62a32 32 0 0 1 64 0v26"
        fill="none"
        stroke="currentColor"
        strokeWidth="30"
        strokeLinecap="round"
      />
      <circle className="mc-mark-dot" cx="184" cy="180" r="17" fill="currentColor" />
    </svg>
  );
}
